import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage } from '@/features/dashboard';

export const Route = createFileRoute('/_authed/_active/s/$storeId/')({
  staticData: { crumb: 'common:nav.dashboard', tours: ['home.store'] },
  component: DashboardPage,
});
